import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2;
var getBackgroundColour = function getBackgroundColour(_ref) {
  var $isVisible = _ref.$isVisible,
    theme = _ref.theme;
  return $isVisible && theme.applyOpacity(theme.colours.layering[0].main, 'overlay');
};
var Background = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n\n  ", "\n"])), getBackgroundColour, function (_ref2) {
  var $disablePointerEvents = _ref2.$disablePointerEvents;
  return $disablePointerEvents && 'pointer-events: none;';
});
var Container = styled.div.attrs(function (_ref3) {
  var $top = _ref3.$top,
    $left = _ref3.$left;
  return {
    style: {
      left: $left,
      top: $top
    }
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  // to apply the fadein animation, we must target the fadein container\n  // which is the first div child of the container\n  & > div {\n    background-color: ", ";\n    max-width: fit-content;\n    box-shadow: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colours.canvas.tertiary.main;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.effects.dropShadow.regular;
});

export { Background, Container };
//# sourceMappingURL=Flyout.styles.js.map
